<template>
  <div class="course-page">
    <p>课程目录</p>
    <ul class="course-list">
      <li class="course-item" @click="handleClick">
        <span>第 <i>0</i> 课</span>
        <span>科学报告下载及完整制作视频</span>
      </li>
      <li class="course-item">
        <span>第 <i>0</i> 课</span>
        <span>科学报告下载及完整制作视频</span>
      </li>
      <li class="course-item">
        <span>第 <i>0</i> 课</span>
        <span>科学报告下载及完整制作视频</span>
      </li>
      <li class="course-item">
        <span>第 <i>0</i> 课</span>
        <span>科学报告下载及完整制作视频</span>
      </li>
      <li class="course-item">
        <span>第 <i>0</i> 课</span>
        <span>科学报告下载及完整制作视频</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
        //
      }
    },
    methods: {
      handleClick () {
        console.log(1111)
        this.$router.push({name: 'demo-detail'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .course-page {
    // max-width: 800px;
    margin: 0 auto;
  }
  .course-list {
    list-style: none;
    padding-left: 0;
    font-size: 20px;
    .course-item {
      height: 80px;
      line-height: 80px;
      background-color: #ffffff;
      border-radius: 10px;
      cursor: pointer;
      &:nth-of-type(odd) {
        background-color: aliceblue;
      }
      &:nth-of-type(even) {
        background-color: antiquewhite;
      }
      & + .course-item {
        margin-top: 10px;
      }
      span {
        &:first-of-type {
          padding: 0 20px;
          border-right: 1px solid rebeccapurple;
        }
        &:last-of-type {
          padding: 0 20px;
          color: #ff7800;
          font-weight: 400;
        }
      }
    }
  }
</style>